import React from 'react';
import PropTypes from 'prop-types';
import { PeriodUnits } from '../utils/constants';
import { formatPrice, getTermText } from '../utils/helpers';
import { NamespaceConsumer, NamespaceShape, withNamespace } from '@ux/namespace-component';

class RenewsAt extends NamespaceConsumer {

  getRenewsAtText() {
    const { item, language, market, currency } = this.props;
    if (item.periodUnit && item.pricing && item.pricing.renewal
      && item.pricing.renewal.unit && item.pricing.renewal.subtotal > 0 && item.pricing.renewal.unit.subtotal > 0) {
      let periodUnit = '';
      let renewalPrice = item.pricing.renewal.subtotal;
      const unitRenewalPrice = item.pricing.renewal.unit.subtotal;

      if (item.periodUnit === PeriodUnits.YEAR) {
        periodUnit = 'renewsAtYear';
        renewalPrice = unitRenewalPrice;
      } else if (item.periodUnit === PeriodUnits.MONTH) {
        periodUnit = 'renewsAtMonth';
        renewalPrice = unitRenewalPrice;
      }

      if (language[periodUnit]) {
        return language[periodUnit].format(formatPrice(market, currency, renewalPrice),
          formatPrice(market, currency, unitRenewalPrice));
      }
      return '';
    }
  }

  render() {
    const { item, language, canRemoveItem } = this.props;

    let renewsAtText = null;
    if (item) {
      const freeForNow = item.pricing.sale === 0 && canRemoveItem;
      if (freeForNow) {
        renewsAtText = language.freeForDuration.format(getTermText(item, language));
      } else {
        renewsAtText = this.getRenewsAtText();
      }
    }

    return renewsAtText && <span>{ renewsAtText }</span>;
  }
}

RenewsAt.propTypes = {
  ...NamespaceShape,
  item: PropTypes.object,
  currency: PropTypes.string.isRequired,
  market: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired
};

export default withNamespace(RenewsAt);
